import { removeCookie } from "@insite/client-framework/Common/Cookies";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { deleteSession } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    DeleteSession as DefaultDeleteSession,
} from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { removeSharedContextCookies, stopWatchingForSharedContextChange } from "@tSurya/Handlers/SharedCookieContext";

const DeleteSession: typeof DefaultDeleteSession = () => {
    stopWatchingForSharedContextChange();
    removeCookie("NavigationMode");

    removeSharedContextCookies();

    return deleteSession();
};

replaceInChain(chain, DefaultDeleteSession, DeleteSession);
